import { Title, Text, SelectorOptionsContainer, SelectorOption } from "../styles";
import { openWindowPopup } from "../utils/windowPopup";

import { Dispatch } from "react";

import { iconMap } from "../../assets/icons";

type Props = {
  productId: string;
  apiUrl :string,
  utm_source: string,
  utm_medium?: string,
  utm_campaign?: string,
  utm_term?: string,
  setCurrentFormOpen:Dispatch<number>;
}

const TalkWithSeller = ({ 
  productId, 
  apiUrl, 
  utm_source,
  utm_medium,
  utm_campaign,
  utm_term,
  setCurrentFormOpen 
} : Props) => {
  const onWhatsClick = async () => {
    try {
      if (!productId || !utm_source) {
        throw new Error("Missing required parameters");
      }

      const params = new URLSearchParams();
      params.append('id_produto', productId);
      params.append('utm_source', utm_source);
      
      if (utm_medium) params.append('utm_medium', utm_medium);
      if (utm_campaign) params.append('utm_campaign', utm_campaign);
      if (utm_term) params.append('utm_term', utm_term);

      params.append('canal', 'whatsapp');
      const url = `${apiUrl}/atendimento?${params.toString()}`;
      openWindowPopup(url);
    } catch (error) {
      console.error("Error in onWhatsClick:", error);
    }
  };

  const onChatClick = async () => {
    try {
      if (!productId || !utm_source) {
        throw new Error("Missing required parameters");
      }

      const params = new URLSearchParams();
      params.append('id_produto', productId);
      params.append('utm_source', utm_source);
      
      if (utm_medium) params.append('utm_medium', utm_medium);
      if (utm_campaign) params.append('utm_campaign', utm_campaign);
      if (utm_term) params.append('utm_term', utm_term);

      const url = `${apiUrl}/atendimento?${params.toString()}`;
      openWindowPopup(url);
    } catch (error) {
      console.error("Error in onChatClick:", error);
    }
  };

  const itens = [
    { title:"Atendimento por Whatsapp", text:"Canal exclusivo para vendas", onClick:() => onWhatsClick(), icon:"whatsapp" },
    { title:"Atendimento por chat", text:"Canal exclusivo para vendas", onClick:() => onChatClick(), icon:"chat" },
    { title:"Atendimento por mensagem", text:"Canal exclusivo para vendas", onClick:() => setCurrentFormOpen(0), icon:"message" },
  ];

  return (
    <div>

      <Title>
        Converse com um corretor
      </Title>

      <Text>
        Selecione uma opção de contato a seguir:
      </Text>

      <SelectorOptionsContainer>
        { itens.map((value) => (
          <button key={ value.title } onClick={ value.onClick }>
            <SelectorOption >
              <div>
                <h3>{value.title}</h3>
                <p>{value.text}</p>
              </div>

            <img
              alt=""
              aria-hidden="true"
              height={ 26 }
              src={iconMap[value.icon] }
              width={ 26 }
            />
            </SelectorOption>
          </button>
        ))}
      </SelectorOptionsContainer>

    </div>
  )
}

export default TalkWithSeller
